import { render, staticRenderFns } from "./configuration-templates-synoptic-templates-modal-external-documentation.vue?vue&type=template&id=9ff2bcc0&scoped=true&"
import script from "./configuration-templates-synoptic-templates-modal-external-documentation.ts?vue&type=script&lang=ts&"
export * from "./configuration-templates-synoptic-templates-modal-external-documentation.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-templates-synoptic-templates-modal-external-documentation.scss?vue&type=style&index=0&id=9ff2bcc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff2bcc0",
  null
  
)

export default component.exports